import Api from './Api';

const END_POINT = 'clients'

export default {
    async get_all(filters = null) {        
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}`, request)
    },
    async get_allPaginated(filters = null) {
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}-list-paginated`, request);
    },
    async store(client) {
        return await Api.post(`${END_POINT}`, client)
    },
    async update(client) {
        return await Api.patch(`${END_POINT}/${client.id}`, client)
    },
    async change_status(client) {
        return await Api.patch(`${END_POINT}/${client.id}/change-status`, client)
    },
    async delete(client) {
        return await Api.delete(`${END_POINT}/${client.id}`, client)
    },
    async upload(client) {
        const config = {
          headers: {
            "content-type": "multipart/form-data",
          },
        };
        return Api.post(`${END_POINT}/upload`, client, config);
    }
}